import { Flex } from '@wyz/ui';
import { WcwCartRow } from '~/purchase/components';
import { IWcwCart, IWcwCartValidationErrorResponse } from '~/purchase/types';

type Props = {
  cart: IWcwCart;
  onRemove: (id: string) => void;
  isRemoving?: boolean;
  validationErrors: IWcwCartValidationErrorResponse['errors'];
};

function WcwCartForm({ cart, onRemove, isRemoving, validationErrors }: Props) {
  return (
    <Flex direction='column' className='gap-3'>
      {cart.items.map((item) => (
        <WcwCartRow
          key={item.id}
          item={item}
          onRemove={onRemove}
          isRemoving={isRemoving}
          errors={validationErrors.find((e) => e.item.id === item.id)?.errors}
        />
      ))}
    </Flex>
  );
}

export default WcwCartForm;
